module.exports = __webpack_public_path__ + "img/score-icon.49e20f74.png";